import Image from '../Image'

export default class GameSceneImage extends Image {
    constructor(src: string) {
        super(src)

        this.element.classList.add('overlay-image')
    }
}
